module.exports = __webpack_public_path__ + "img/19.37ef4732.jpg";